import {
    standardActionErrorMsg, standardActionSuccessMsg, StandardActionToastMessages
} from '~commonInfra/contentActions/ActionHelpers';
import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { Set } from '~commonInfra/utils/Set';
import { Formatters, Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { FlowBaseInfo } from '~src/flow/models/FlowInfo';
import { Flows } from '~src/flow/resources/Flows';
import { FlowContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';
import { ChangeTagsActionHelperService } from '~src/tags/ChangeTagsActionHelper';
import { IChangeContentTagsResult } from '~src/tags/IChangeContentTagsAction';

export namespace ChangeFlowsTagsAction {
  const notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsFlowsSuccess),
    error: standardActionErrorMsg(Messages.changeTagsFlowsError),
  };

  export function execute(itemSet: Set<FlowBaseInfo>): Promise<IChangeContentTagsResult> {
    return ChangeTagsActionHelperService.createExecuteFn<FlowBaseInfo>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => Flows.changeTags(ids, addTags, removeTags),
      getDescription: (flows: Set<FlowBaseInfo>) => getDescription(flows),
      notificationFns: notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<FlowBaseInfo>) => changeTagsErrorDetail(errorItem)
    })(itemSet);
  }

  function getDescription(flows: Set<FlowBaseInfo>) {
    return (flows.size() === 1)
      ? Messages.changeTagsFlowDescription({ NAME: L10n.elideIfLong(flows.first().name) })
      : Messages.changeTagsFlowsDescription({ COUNT_LOC: Formatters.formatCount(flows.size()) });
  }

  function changeTagsErrorDetail(errorItem: IErrorItem<FlowBaseInfo>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, FlowContentType),
      errorMessage: ChangeTagsActionHelperService.errorMessageFor(errorItem)
    };
  }
}
